<script setup>
import { computed, defineAsyncComponent } from 'vue';

import TheFooter from '@/components/Layout/Components/TheFooter.vue';
import TheForm from '@/components/Layout/Components/TheForm.vue';
import TheHeader from '@/components/Layout/Components/TheHeader.vue';
import TheDevBar from '@/components/TheDevBar.vue';
import ErrorMessage from '@/components/Views/Funnels/shared/all-funnels/components/ErrorMessage.vue';
import { formStore } from '@/stores/form.js';

const form = formStore();

// import the aside for the current Funnels
const TheAside = defineAsyncComponent(() => import(`@/components/Views/Funnels/${form.funnelType}/TheAside.vue`));
const TheAsideMobile = defineAsyncComponent(
  () => import(`@/components/Views/Funnels/${form.funnelType}/offcanvas/TheAsideMobile.vue`),
);

const hideUspSection = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideChatBox = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideHelpCenter = computed(() => ['insuretostudy'].includes(form.tenant));
const hideFooter = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
</script>

<template>
  <div class="wrapper">
    <BaseSpinner v-if="form.baseSpinner" />
    <BaseLoader v-if="form.baseLoader" />
    <TheDevBar v-if="form.getFunnelVersion === 'dev-local' || form.devMode" />
    <TheHeader
      :disabled-usp-section="hideUspSection"
      :disabled-chat-box="hideChatBox"
      :disabled-help-center="hideHelpCenter"
    />
    <main>
      <div class="container-lg">
        <div class="row">
          <div class="col-12 col-lg-7 col-xxl-8">
            <!-- The app form -->
            <TheForm :key="form.stepKey">
              <ErrorMessage v-if="form.error" />

              <slot />
            </TheForm>
          </div>
          <div class="d-none d-lg-block col-lg-5 col-xxl-4">
            <!-- The app sidebar -->
            <component :is="TheAside" />
          </div>
        </div>
      </div>
    </main>
    <!-- The footer -->
    <TheFooter v-if="!hideFooter" />

    <!-- TheAside on mobile -->
    <component :is="TheAsideMobile" />
  </div>
</template>
